import CustomTabs from "../../../components/CustomTabs/CustomTabs.js";
import Tasks from "../../../components/Tasks/Tasks.js";
import GridItem from "../../../components/Grid/GridItem.js";
import DateRangeIcon from '@material-ui/icons/DateRange';
import MDBox from "components/MDBox";
import CircularProgress from '@mui/material/CircularProgress';
import { formatAmountWithRupeeSymbol } from "../../../common.js";
import { useTranslation } from "react-i18next";
function EarningReports(props) {

  const { t }        = useTranslation();

  let earningReportDataToday   = [];
  let earningReportDataWeek    = [];
  let earningReportDataMonth   = [];
  let earningReportDataYear    = [];
  let earningReportDataAllTime = [];

  let earningsObjectToday     = props.earningsObjectToday;
  let earningsObjectWeek      = props.earningsObjectWeek;
  let earningsObjectMonth     = props.earningsObjectMonth;
  let earningsObjectYear      = props.earningsObjectYear;
  let earningsObjectAllTime   = props.earningsObjectAllTime;
  let isEarningsLoading       = props.isEarningsLoading;
  let tabOnClick              = props.tabOnClick;

  if(Object.keys(earningsObjectToday).length > 0)
  {
    earningReportDataToday = [
      t("Total Sales")+'    : '+formatAmountWithRupeeSymbol(parseFloat(earningsObjectToday.sellerTotalEarning) + parseFloat(earningsObjectToday.adminTotalCommission)),
      t("Vendor Commission")+'   : '+formatAmountWithRupeeSymbol(earningsObjectToday.sellerTotalEarning),
      t("Admin Commission")+'  : '+formatAmountWithRupeeSymbol(earningsObjectToday.adminTotalCommission),
    ]; 
  }

  if(Object.keys(earningsObjectWeek).length > 0)
  {
    earningReportDataWeek = [    
      t("Total Sales")+'    : '+formatAmountWithRupeeSymbol(parseFloat(earningsObjectWeek.sellerTotalEarning) + parseFloat(earningsObjectWeek.adminTotalCommission)),
      t("Vendor Commission")+'   : '+formatAmountWithRupeeSymbol(earningsObjectWeek.sellerTotalEarning),
      t("Admin Commission")+'  : '+formatAmountWithRupeeSymbol(earningsObjectWeek.adminTotalCommission),
    ];  
  }

  if(Object.keys(earningsObjectMonth).length > 0)
  {
    earningReportDataMonth = [    
      t("Total Sales")+'    : '+formatAmountWithRupeeSymbol(parseFloat(earningsObjectMonth.sellerTotalEarning) + parseFloat(earningsObjectMonth.adminTotalCommission)),
      t("Vendor Commission")+'   : '+formatAmountWithRupeeSymbol(earningsObjectMonth.sellerTotalEarning),
      t("Admin Commission")+'  : '+formatAmountWithRupeeSymbol(earningsObjectMonth.adminTotalCommission),
    ];  
  }

  if(Object.keys(earningsObjectYear).length > 0)
  {
    earningReportDataYear = [    
      t("Total Sales")+'    : '+formatAmountWithRupeeSymbol(parseFloat(earningsObjectYear.sellerTotalEarning) + parseFloat(earningsObjectYear.adminTotalCommission)),
      t("Vendor Commission")+'   : '+formatAmountWithRupeeSymbol(earningsObjectYear.sellerTotalEarning),
      t("Admin Commission")+'  : '+formatAmountWithRupeeSymbol(earningsObjectYear.adminTotalCommission),
    ];  
  }  

  if(Object.keys(earningsObjectAllTime).length > 0)
  {
    earningReportDataAllTime = [    
      t("Total Sales")+'    : '+formatAmountWithRupeeSymbol(parseFloat(earningsObjectAllTime.sellerTotalEarning) + parseFloat(earningsObjectAllTime.adminTotalCommission)),
      t("Vendor Commission")+'   : '+formatAmountWithRupeeSymbol(earningsObjectAllTime.sellerTotalEarning),
      t("Admin Commission")+'  : '+formatAmountWithRupeeSymbol(earningsObjectAllTime.adminTotalCommission),
    ];  
  }  
  
  return (
    (
      earningReportDataToday.length > 0 || 
      earningReportDataWeek.length > 0 || 
      earningReportDataMonth.length > 0 || 
      earningReportDataYear.length > 0 || 
      earningReportDataAllTime.length > 0       
    ) ? 
      <GridItem xs={12} sm={6} className="rowTableCell rowTableCell-Earnings">
          {isEarningsLoading ?       
            <MDBox py={3} sx={{ textAlign: "center", position: "absolute", top: 75, zIndex: 100, width: "100%" }}>   
              <CircularProgress size={30} style={{color: '#1a90ff', margin: '0px auto'}}/>
            </MDBox>
          : null}        
        <CustomTabs
          title={t("Earnings")+" : "}
          headerColor="rose"
          tabOnClick={tabOnClick}
          tabs={[
            {
              tabName: "Today",
              tabValue: "today",
              tabSection: "earnings",  
              tabIcon: DateRangeIcon,
              tabContent: (
                <Tasks
                  tasksIndexes={[0, 1, 2]}
                  tasks={earningReportDataToday}
                />
              ),
            },
            {
              tabName: "This Week",
              tabValue: "week",
              tabSection: "earnings",                
              tabIcon: DateRangeIcon,
              tabContent: (
                <Tasks
                  tasksIndexes={[0, 1, 2]}
                  tasks={earningReportDataWeek}
                />
              ),
            },
            {
              tabName: "This Month",
              tabValue: "month",
              tabSection: "earnings",                
              tabIcon: DateRangeIcon,
              tabContent: (
                <Tasks
                  tasksIndexes={[0, 1, 2]}
                  tasks={earningReportDataMonth}
                />
              ),
            },
            {
              tabName: "This Year",
              tabValue: "year",
              tabSection: "earnings",  
              tabIcon: DateRangeIcon,
              tabContent: (
                <Tasks
                  tasksIndexes={[0, 1, 2]}
                  tasks={earningReportDataYear}
                />
              ),
            },
            {
              tabName: "All Time",
              tabValue: "all-time",
              tabSection: "earnings",  
              tabIcon: DateRangeIcon,
              tabContent: (
                <Tasks
                  tasksIndexes={[0, 1, 2]}
                  tasks={earningReportDataAllTime}
                />
              ),
            },
          ]}
        />
      </GridItem>
    : <></>  
  )
}

export default EarningReports;